import {
    setCookie,
    getCookie,
    isFunc,
    n2v
} from '../Often';
import {setLocal, removeLocal, getLocalValue} from '../LocalStorage'
import {toast} from '../Toast';
import {checkFlowVersion, checkFlowNewVersion, autoUpdate, checkForUpdateManually} from './download';

const isElectronApp = () => {
    return n2v(getLocalValue("ONLY_ELECTRON_YN"), "N") === "Y";
}

const init = (isLoginState) => {
    if (!isElectronAvailable()) return;
    if (Often.isFunc("DESKTOP_AUTO_UPDATE")) autoUpdate({isSilentUpdate: true});
    // setElectronGlobalVariable({key: 'ELECTRON_SAVE_LAST_URL', data: Often.isFunc('ELECTRON_SAVE_LAST_URL')})
    openMenuVisibleValue();
    // etcLogic();
    setUserInfo();

    function openMenuVisibleValue() {
        if (Often.isMessenger()) return;
        ElectronApi.Window.setMenuVisibleValue({
            logoutMenuVisible: isLoginState,
            lockMenuVisible: isLoginState && _USE_INTT_ID.indexOf("KAKAO") === -1 && _USE_INTT_ID.indexOf("APPLE") === -1 && _USE_INTT_ID.indexOf("GMAIL") === -1,
            windowModeVisible: isLoginState,
            serverMenuVisible: (ServerChecker.isMadras || Often.isServerModeByHost("DEV_TEST")),
            alphaDownloadVisible: Often.isFunc('ELECTRON_ALPHA_VERSION_OPEN'),
        })
    }

    function etcLogic() {
        if (ServerChecker.isSeco || ServerChecker.isZoomok) {
            $('body').off('mouseenter mouseleave mousedown keypress').on('mouseenter mouseleave mousedown keypress', function () {
                MiniLock.setLockState(true);
            });
        }
    }

    function setUserInfo() {
        const writeDnsErrorLog = Often.isFunc('WRITE_ELECTRON_SESSION_ERROR_LOG')

        ElectronApi.Comm.setConfig({'key': 'USER_ID', 'value': _USER_ID})
        ElectronApi.Comm.setConfig({'key': '_USE_INTT_ID', 'value': _USE_INTT_ID})
        ElectronApi.Comm.setConfig({'key': 'writeSessionErrLog', 'value': writeDnsErrorLog})
    }
}


const setConfig = (props) => {
    try {
        if (window.ElectronProcessApi) runElectronFunc('ElectronProcessApi', 'setConfig', props);
        else fn_setOneConfigForElectron(props.key, props.value)
    } catch (e) {
        console.error('setConfig', '웹에서 미니를 켰습니다!');
    }
}
const getName = () => {
    try {
        if (window.ElectronProcessApi) return runElectronFunc('ElectronProcessApi', 'getName');
        else return fn_ElectronNameCheck()
    } catch (e) {
        console.error('getName', '웹에서 미니를 켰습니다!');
    }
}
const getConfig = (props) => runElectronFunc('ElectronProcessApi', 'getConfig', props);
const getConfigs = () => {
    if (window.ElectronProcessApi) return runElectronFunc('ElectronProcessApi', 'getConfigs');
    try {
        return fn_getConfigsForElectron();
    } catch (e) {
        console.error('getConfigs', '웹에서 미니를 켰습니다!');
        return {b_fullmode: false}
    }
}
const getVersion = () => {
    if (window.ElectronProcessApi) return ElectronProcessApi.getVersion();
    else return fn_ElectronVersionCheck();
}
const isElectron = () => n2v(getLocalValue("ONLY_ELECTRON_YN", "N")) === "Y";
const reload = (isClearCache = false) => runElectronFunc('ElectronWindowApi', 'reload', {isClearCache});
const relaunchApp = () => runElectronFunc('ElectronProcessApi', 'relaunchApp');

const isElectronAvailable = () => {
    try {
        const electronVersion = n2v(getVersion(), '');
        setAppDataElectron(electronVersion && electronVersion !== '' ? "Y" : "N", electronVersion);
        return true
    } catch (e) {
        setAppDataElectron("N", '');
        return false
    }
}

const setAppDataElectron = (yn, version) => {
    if (version && version !== '') {
        setCookie("electronVer", version);
        setLocal("ONLY_ELECTRON_VER", version);
    } else {
        removeLocal("ONLY_ELECTRON_VER");
    }
    LocalUtil.setLocal("ONLY_ELECTRON_YN", yn);
    setCookie("electronYn", yn);
}

const runElectronFunc = (moduleName, FuncName, props) => {
    try {
        const electronApi = window[moduleName]?.[FuncName];
        if(electronApi === undefined) Mutil.mlog(`runElectronFunc error ::::  ${moduleName}.${FuncName} is undefined`);
        return electronApi(props);
    } catch (e) {
        console.error(e);
        Mutil.mlog(`runElectronFunc error ::::  ${moduleName}.${FuncName} is undefined`);
        toast('error', i18next.t(main.alert.errorTryAgain));
        return false;
    }
}

const showVersionLimit = async (props={}) => {
    const appName = await getName();
    if (Often.isFunc(Func.CLOUD.STOP_FLOWNEW) && appName.indexOf('new') > -1) checkFlowNewVersion();
    else if (Often.isFunc(Func.CLOUD.DESKTOP_UPDATE_POPUP)) checkFlowVersion().then(() => {
        if (Often.isFunc('ELECTRON_ALPHA_VERSION_OPEN')) {
            const {isInit = false} = props
            if (!isInit) {
                ElectronApi.Comm.checkSpecialUpdateManually();
            }
        }
    });
}

const checkSpecialUpdateManually = (props = {}) => {
    const {key = 'ELECTRON_CUSTOM_VER_UPDATE', showPopupDialog = false} = props
    const _props = {
        updateChannel: getUpdateChannel(key),
        ...props
    }

    setTimeout(() => {
        checkForUpdateManually(_props);
    }, 500);
}

const getUpdateChannel = (key) => {
    const customUpdateChannel = getCustomFunKeyValue({key});
    if(customUpdateChannel !== '') {
        return customUpdateChannel;
    }
    return Often.isFunc('ELECTRON_ALPHA_VERSION_OPEN') ? 'alpha' : '';
}


const getCustomFunKeyValue = (props = {}) => {
    const {key='ELECTRON_CUSTOM_VER_UPDATE'} = props;
    const funcKeyString = LocalUtil.getLocal("ONLY_FUNC_LIST");
    if (!funcKeyString) {
        return '';
    }
    const funKeyListJson = JSON.parse(funcKeyString);
    const result = [];

    for (let item in funKeyListJson) {
        if (item.startsWith(key)) {
            const value = item.split(':::')[1];
            return value.toLowerCase();
        }
    }
    return ''
}

const setAjaxErrorToElectron = (props={}) => {
    const {e, apiKey, roomSrno, url} = props
    let roomKey;
    const isMini = !getConfig('b_fullMode')
    if (roomSrno) {
        roomKey = `POPUP_CHAT_${roomSrno}`;
    } else if (isMini) {
        roomKey = url.includes('miniMain') ? 'main' : 'project';
    } else {
        roomKey = url.includes('main') ? 'main' : ''
    }
    if(!roomKey) Mutil.clog('해당 없는 지역')

    const data = {
        appendKey:roomKey,
        appendValue:apiKey,
    }

    setElectronGlobalVariable({key:'pendingApiMap', mode:'appendData', data})
}

const setElectronGlobalVariable = (props={}) => {
    const {key, data, mode} = props
    if(!window.ElectronProcessApi) return
    window.ElectronProcessApi.setElectronGlobalVar(props)
}

const isTimePassedThreshold = () => {
    const checkedTime = localStorage.getItem('versionCheckedTime') || '';
    const currentTime = dayjs().format('YYYYMMDDHHmmss')

    const comparisonTime = 5

    if (!checkedTime || dayjs().diff(dayjs(checkedTime, 'YYYYMMDDHHmmss'), 'minute') > comparisonTime) {
        localStorage.setItem('versionCheckedTime', currentTime)
        return true
    }
    return false
}

const electronImprovedVersionCheck = (props={}) => {
    const {$eTarget=''} = props
    const isElectronImprovedVersionCheck = Often.isFunc('ELECTRON_IMPROVED_VERSION_CHECK');
    const isSecure = Often.isFunc('SECURE_CONNECT');
    const isEnter = ServerChecker.isEnter;
    if (!isElectronImprovedVersionCheck || isSecure || isEnter ||!$eTarget) return
    const isNotLeftBottomUl = $eTarget.closest('#leftBottomUl').length === 0;
    // const isMadrascheckEmployee ServerChecker.isMadras
    if (!isSecure && !isEnter && isElectronImprovedVersionCheck && isNotLeftBottomUl && isTimePassedThreshold()) {
        checkFlowVersion().then(() => {
            const isAlphaVersionOpen = Often.isFunc('ELECTRON_ALPHA_VERSION_OPEN');
            if (isAlphaVersionOpen) ElectronApi.Comm.checkSpecialUpdateManually();
        });
    }
}

const isShiftCtrlAltEvent = (event = {}) => {
    if (event.shiftKey || event.altKey || event.ctrlKey) return true;
    else return false
}


export {
    init,
    setConfig,
    isElectronApp,
    isElectronAvailable,
    runElectronFunc,
    getConfig,
    getVersion,
    getName,
    isElectron,
    showVersionLimit,
    getConfigs,
    reload,
    relaunchApp,
    checkSpecialUpdateManually,
    setAjaxErrorToElectron,
    setElectronGlobalVariable,
    electronImprovedVersionCheck,
    isTimePassedThreshold,
    isShiftCtrlAltEvent
};
